import { AutocompleteAddress } from "@/services/bpost.service";

export const getDisplayValue = (address: AutocompleteAddress | null) => {
    const displayValue = address?.isComplete
        ? address?.string
        : address?.searchBarString || address?.string;

    return displayValue ?? "";
};
